import { Breadcrumb } from "@/base/components/index";
import { Link as RouterLink } from "react-router-dom";
import { HeaderBreadcrumbProps } from "../types/index";
import { useHeaderStyles } from "./header.styles";

export const HeaderBreadcrumb = ({
  items,
  className,
}: HeaderBreadcrumbProps) => {
  const { styles, cx } = useHeaderStyles();

  return (
    <div className={cx(className, styles.breadcrumb)}>
      <Breadcrumb
        items={items?.map(({ href, title, ...item }) => ({
          title: href ? (
            <RouterLink to={href || ""}>{title}</RouterLink>
          ) : (
            title
          ),
          ...item,
        }))}
      />
    </div>
  );
};
